import React, { useContext } from 'react';
import type Stripe from 'stripe';
import type { SetupIntent } from '@stripe/stripe-js';
import { AppContext, initialState } from '../../context/AppContext/context';

export type SetupIntentResult = SetupIntent | null;

type Options = {
  setupIntent: Stripe.SetupIntent;
  title?: string;
  buttonText?: string;
};

const initialPaymentMethodModalState = initialState.paymentMethodModal;

function usePaymentMethodCollection() {
  const { dispatch } = useContext(AppContext);

  const update = React.useCallback(
    (payload: typeof initialPaymentMethodModalState) => {
      dispatch({
        type: 'SET_PAYMENT_METHOD_MODAL',
        payload,
      });
    },
    [dispatch],
  );

  const collectPaymentMethod = React.useCallback(
    async (options: Options) =>
      new Promise<SetupIntentResult>(promiseResolve => {
        const resolve: (result: SetupIntentResult) => void = result => {
          promiseResolve(result);
          update({
            ...initialPaymentMethodModalState,
            status: 'resolved',
          });
        };
        update({
          ...initialPaymentMethodModalState,
          setupIntent: options.setupIntent,
          status: 'awaiting',
          resolve,
          title: options.title,
          buttonText: options.buttonText,
        });
      }),
    [update],
  );

  return collectPaymentMethod;
}

export default usePaymentMethodCollection;
